import { render } from "./add_task.html?vue&type=template&id=45374c81&external"
import script from "./add_task.js?vue&type=script&lang=js&external"
export * from "./add_task.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__